import { useState, useEffect } from "react";
import { Routes, Route} from "react-router-dom";
import { BrowserRouter } from "react-router-dom";

import Search from "./components/searchbar/searchbar.component";
import Resource from "./components/resource/resource.component";
import Home from "./components/home/home.component";
import Resources from "./components/resources/resources.component";
import RedirectComponent from "./components/RedirectComponent/redirectcomponent.component"
import MapComponent from "./components/Map/map.component"
import BreadCrumb from "./components/BreadCrumb/breadcrumb.component";

import "./App.css";
import { setSelectionRange } from "@testing-library/user-event/dist/utils";

import { useTranslation } from "react-i18next";
import "./translations/i18n";

const App = () => {
  const { REACT_APP_MY_LANG, REACT_APP_MY_URL, REACT_APP_MY_API_URL } =
    process.env;

  
  
  const [lang, setLang] = useState(REACT_APP_MY_LANG);
  const [apiUrl, setApiUrl] = useState(REACT_APP_MY_API_URL);
  const [globalSearchString, setGlobalSearchString] = useState("");
  const [globalSearchType, setGlobalSearchType] = useState("");

  const [filteredResources, setFilteredResources] = useState([]);
  const [searchUrl, setSearchUrl] = useState("");

  const [types, setTypes] = useState([]);

  const { t, i18n } = useTranslation();

  useEffect(() => {
  let elem = document.getElementsByClassName("bogo-language-switcher")[0]
  if (elem !== null)
    {  
      const bogo_en = `
        <li class="en-US en current first"><span class="bogoflags bogoflags-us"></span> <span class="bogo-language-name"><a 
                    rel="alternate" hreflang="en-US" href="#"
                    class="current" id="bogo_en"  aria-current="page" title="English" onclick="function c() 
                    {window.location.href=window.location.href.replace('/katalog','/catalogue')}
                    ;c();">English</a></span></li>
        <li class="pl-PL pl last"><span class="bogoflags bogoflags-pl"></span> <span class="bogo-language-name"><a onclick="function c()
        {window.location.href=window.location.href.replace('/catalogue','/katalog')}
        ;c();"
                    rel="alternate" hreflang="pl-PL" href="#" title="Polish" id="bogo_pl"
                   >polski</a></span></li>
       `
       const bogo_pl = `
       <li class="en-US en first"><span class="bogoflags bogoflags-us"></span> <span class="bogo-language-name"><a onclick="function c() 
       {window.location.href=window.location.href.replace('/katalog','/catalogue')}
       ;c();"
                   rel="alternate" hreflang="en-US" href="#"
                   title="English" id="bogo_pl">English</a></span></li>
       <li class="pl-PL pl current last"><span class="bogoflags bogoflags-pl"></span> <span class="bogo-language-name"><a onclick="function c()
       {window.location.href=window.location.href.replace('/catalogue','/katalog')}
       ;c();"
                   rel="alternate" hreflang="pl-PL" href="#" title="Polish"
                   class="current" id="bogo_pl" aria-current="page">polski</a></span></li>
      `
      if (REACT_APP_MY_LANG === 'en') {
        elem.innerHTML = bogo_en;
        
      }
      else {
        elem.innerHTML = bogo_pl;
        
      }
    }
  }, []);

  useEffect(() => {
    
    fetch(REACT_APP_MY_API_URL + "Types")
      .then((response) => response.json())
      .then((types) => setTypes(types));
  }, []);

  const onGlobalSearchChange = (searchString, searchType) => {
    //console.log(searchString, searchType);
    if (searchString) setGlobalSearchString(searchString);
    if (searchType) setGlobalSearchType(searchType);
  };

  const onFilteredResourcesChange = (newFilteredResources) => {
    if (newFilteredResources) {
      setFilteredResources(newFilteredResources);
      //console.log(newFilteredResources)
    }
  };

  const onSearchUrlChange = (newSearchUrl) => {
    setSearchUrl(newSearchUrl);
  };

  const onClearGlobalSearchString = () => {
    //console.log("remove global search string")
    //setGlobalSearchString(new String(""));
    setGlobalSearchString("");
  };

  const onClearGlobalSearchType = () => {
    //console.log("remove global search type")
    //setGlobalSearchType(new String(''));
    setGlobalSearchType(null);
  };

  return (
    <BrowserRouter basename={REACT_APP_MY_URL}>
      <Routes>
        <Route
          path="/"
          element={
            <Search
              types={types}
              onGlobalSearchChange={onGlobalSearchChange}
              globalSearchType={globalSearchType}
              globalSearchString={globalSearchString}
              apiUrl={apiUrl}
              lang={lang}
            />
          }
        >
          <Route index element={<Home apiUrl={apiUrl} />} />



          <Route path="/:labID" 
             element={
                <RedirectComponent /> 
             }
           /> 

          <Route path="map/:resourceId" 
            element={
              <div className="dariah-map-page">
                  <MapComponent apiUrl={apiUrl} lang={lang} />
              </div>
                          }
          />

          <Route path="map/" 
            element={
              <>
                <BreadCrumb paths={
              [
                  {
                    Name: t('breadcrumb.start.name'),
                    Url: t('breadcrumb.start.url')
                  },
                  {
                    Name: t('breadcrumb.infrastructure.name'),
                    Url: t('breadcrumb.infrastructure.url')
                  },
                  {
                    Name:t('breadcrumb.catalogue.name'),
                    Url:t('breadcrumb.catalogue.url'),
                  },
                  {
                    Name:t('breadcrumb.map.name'),
                    Url: ''
                  },
              ]
              }
          />
  
      <div className="resources-header">
        <h1>{t('map.name')}</h1>
  
      </div>
              <div className="dariah-map-page">
                  <MapComponent apiUrl={apiUrl} lang={lang}/>
              </div>
              </>
            }
          />

          <Route
            path="resources/:resourceId"
            element={
              <Resource
                apiUrl={apiUrl}
                lang={lang}
                filteredResources={filteredResources}
                searchUrl={searchUrl}
              />
            }
          />
          {/* <Route path='search/:searchStr' element={<Resources apiUrl={apiUrl} />}/> */}
          <Route
            path="search/"
            element={
              <Resources
                apiUrl={apiUrl}
                globalSearchString={globalSearchString}
                globalSearchType={globalSearchType}
                onFilteredResourcesChange={onFilteredResourcesChange}
                onSearchUrlChange={onSearchUrlChange}
                onClearGlobalSearchString={onClearGlobalSearchString}
                onClearGlobalSearchType={onClearGlobalSearchType}
              />
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
